import { Fragment, useMemo, useState } from 'react'
import { useBreadcrumb } from '../hooks/useBreadcrumb'
import toast from 'react-hot-toast'
import { FaClipboardList, FaSearch, FaRedo, FaEye, FaChevronDown, FaChevronRight } from 'react-icons/fa'
import { Card, PageHeader, EmptyState, Button, PhoneTailVerifyModal, MobileCard, Modal } from '../components/common'
import { useAuth } from '../hooks/useAuth'

// ⚠️ 静态页面：以下均为前端本地 mock 数据，不对接后端接口，仅用于演示「我的订单」页面风格与「未登录 / 查询非本人订单」的手机后四位校验流程。
// mine=true 为「当前用户」的订单（登录后在下方列表展示）；mine=false 为「他人」订单（登录用户查询时同样需要校验）。
const MOCK_ORDERS = [
  {
    id: 1,
    mine: true,
    orderNo: 'DD-2026-000101',
    waybillNo: 'YD202607180001',
    cargoType: '普货',
    cargoName: '蓝牙耳机',
    recipient: '张伟',
    phone: '13800138001',
    address: '肯尼亚 内罗毕市 Westlands Road 123 号',
    transportPlan: '海运整柜',
    containerType: '20GP',
    orderTime: '2026-03-18 09:32:15',
    pieces: 120,
    weight: 860.5,
    volume: 24.3200,
    remark: '客户要求加固木架包装',
  },
  {
    id: 2,
    mine: true,
    orderNo: 'DD-2026-000102',
    waybillNo: 'YD202607180002',
    cargoType: '带电',
    cargoName: '充电宝套装',
    recipient: '李娜',
    phone: '13900139002',
    address: '坦桑尼亚 达累斯萨拉姆 Kariakoo 市场 45 号',
    transportPlan: '海运拼箱',
    containerType: '拼箱',
    orderTime: '2026-03-18 14:05:47',
    pieces: 30,
    weight: 210.0,
    volume: 3.8600,
    remark: '带电产品，需提供 MSDS',
  },
  {
    id: 3,
    mine: true,
    orderNo: 'DD-2026-000103',
    waybillNo: 'YD202607190003',
    cargoType: '纺织品',
    cargoName: '女装连衣裙',
    recipient: '王强',
    phone: '13700137003',
    address: '尼日利亚 拉各斯 Lekki Phase 1, Block 5',
    transportPlan: '空运拼货',
    containerType: '—',
    orderTime: '2026-03-19 11:20:03',
    pieces: 50,
    weight: 180.0,
    volume: 2.1000,
    remark: '',
  },
  {
    id: 4,
    mine: true,
    orderNo: 'DD-2026-000104',
    waybillNo: 'YD202607190004',
    cargoType: '普货',
    cargoName: '陶瓷茶具',
    recipient: '赵敏',
    phone: '13600136004',
    address: '南非 约翰内斯堡 Sandton City Mall 附近仓库',
    transportPlan: '海运整柜',
    containerType: '40HQ',
    orderTime: '2026-03-19 16:48:52',
    pieces: 300,
    weight: 4200.0,
    volume: 62.0000,
    remark: '易碎品，全程小心搬运',
  },
  {
    id: 5,
    mine: true,
    orderNo: 'DD-2026-000105',
    waybillNo: 'YD202607200005',
    cargoType: '液体',
    cargoName: '护肤精华液',
    recipient: '陈静',
    phone: '13500135005',
    address: '加纳 阿克拉 Osu Oxford Street 88 号',
    transportPlan: '海运拼箱',
    containerType: '拼箱',
    orderTime: '2026-03-20 08:11:29',
    pieces: 40,
    weight: 96.0,
    volume: 1.2400,
    remark: '液体货，需符合目的港进口要求',
  },
  {
    id: 6,
    mine: true,
    orderNo: 'DD-2026-000106',
    waybillNo: 'YD202607200006',
    cargoType: '敏感货',
    cargoName: '仿牌运动鞋',
    recipient: '刘洋',
    phone: '13400134006',
    address: '埃及 开罗 Nasr City 第 7 区 12 号',
    transportPlan: '海运整柜',
    containerType: '40GP',
    orderTime: '2026-03-20 10:26:37',
    pieces: 500,
    weight: 3600.0,
    volume: 55.5000,
    remark: '敏感货渠道，报关资料已备齐',
  },
  // —— 以下为「他人」订单（登录用户查询时需校验手机后四位；游客亦可凭订单号 + 后四位查询）——
  {
    id: 7,
    mine: false,
    orderNo: 'DD-2026-000201',
    waybillNo: 'YD202607150007',
    cargoType: '普货',
    cargoName: '蓝牙音箱',
    recipient: '孙悦',
    phone: '13011110007',
    address: '摩洛哥 卡萨布兰卡 Maarif 区 20 号',
    transportPlan: '海运拼箱',
    containerType: '拼箱',
    orderTime: '2026-03-15 09:10:22',
    pieces: 20,
    weight: 120.0,
    volume: 1.5600,
    remark: '',
  },
  {
    id: 8,
    mine: false,
    orderNo: 'DD-2026-000202',
    waybillNo: 'YD202607150008',
    cargoType: '普货',
    cargoName: '保温杯',
    recipient: '周杰',
    phone: '13022220008',
    address: '科特迪瓦 阿比让 Plateau 区 5 号',
    transportPlan: '海运整柜',
    containerType: '40HQ',
    orderTime: '2026-03-15 15:42:08',
    pieces: 260,
    weight: 1800.0,
    volume: 30.0000,
    remark: '',
  },
]

const EMPTY_QUERY = { orderNo: '', waybillNo: '' }

export default function MyOrdersPage() {
  const breadcrumb = useBreadcrumb()
  const { isAuthenticated } = useAuth()
  const [query, setQuery] = useState(EMPTY_QUERY)
  const [expandedRows, setExpandedRows] = useState({})
  // 凭「订单号/运单号 + 收件人手机号后四位」校验查得的订单（游客、或登录用户查询非本人订单时使用）
  const [queryResult, setQueryResult] = useState(null)
  const [detailModal, setDetailModal] = useState({ visible: false, order: null })
  const [verifyModal, setVerifyModal] = useState({ visible: false, code: '' })

  // 当前用户的订单（仅登录展示）
  const myOrders = useMemo(() => MOCK_ORDERS.filter((o) => o.mine), [])

  // 下方列表：按订单号 / 运单号模糊过滤本人订单
  const filteredMyOrders = useMemo(() => {
    const orderNo = query.orderNo.trim().toLowerCase()
    const waybillNo = query.waybillNo.trim().toLowerCase()
    return myOrders.filter((o) => {
      if (orderNo && !String(o.orderNo).toLowerCase().includes(orderNo)) return false
      if (waybillNo && !String(o.waybillNo).toLowerCase().includes(waybillNo)) return false
      return true
    })
  }, [myOrders, query])

  const toggleExpandRow = (order) => {
    setExpandedRows((prev) => ({ ...prev, [order.id]: !prev[order.id] }))
  }

  // 点击「查询」：本人订单直接由下方列表过滤展示；游客或查询非本人订单则弹窗校验手机后四位
  const handleQuery = () => {
    const orderNo = query.orderNo.trim()
    const waybillNo = query.waybillNo.trim()
    const code = orderNo || waybillNo
    if (!code) {
      toast.error('请输入订单号或运单号')
      return
    }
    setQueryResult(null)
    if (isAuthenticated) {
      const isOwn = myOrders.some(
        (o) =>
          (orderNo && String(o.orderNo).toLowerCase().includes(orderNo.toLowerCase())) ||
          (waybillNo && String(o.waybillNo).toLowerCase().includes(waybillNo.toLowerCase()))
      )
      if (isOwn) {
        // 本人订单：下方列表已按搜索词过滤展示，无需校验
        return
      }
    }
    setVerifyModal({ visible: true, code })
  }

  const handleReset = () => {
    setQuery(EMPTY_QUERY)
    setQueryResult(null)
  }

  // 弹窗提交：校验「订单号/运单号 + 收件人手机号后四位」，通过后展示该单
  const handleVerify = (phoneTail) => {
    const code = verifyModal.code.trim().toLowerCase()
    const order = MOCK_ORDERS.find(
      (o) =>
        String(o.orderNo).toLowerCase() === code || String(o.waybillNo).toLowerCase() === code
    )
    if (!order) {
      toast.error('未找到该订单，请核对订单号 / 运单号')
      return
    }
    if (!String(order.phone).endsWith(phoneTail)) {
      toast.error('手机号后四位不正确')
      return
    }
    setQueryResult(order)
    setVerifyModal({ visible: false, code: '' })
    toast.success('校验成功')
  }

  const openDetail = (order) => setDetailModal({ visible: true, order })
  const closeDetail = () => setDetailModal({ visible: false, order: null })

  return (
    <div>
      <PageHeader
        icon={FaClipboardList}
        title="我的订单"
        subtitle="查看和管理您的所有订单"
        breadcrumb={breadcrumb}
      />

      <div className="container py-8">
        {/* 查询区 */}
        <Card className="mb-6">
          <Card.Body>
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <div className="relative">
                  <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="请输入订单号（模糊查询）"
                    className="form-control pl-10"
                    value={query.orderNo}
                    onChange={(e) => setQuery({ ...query, orderNo: e.target.value })}
                    onKeyDown={(e) => e.key === 'Enter' && handleQuery()}
                  />
                </div>
              </div>
              <div className="flex-1">
                <div className="relative">
                  <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="请输入运单号（模糊查询）"
                    className="form-control pl-10"
                    value={query.waybillNo}
                    onChange={(e) => setQuery({ ...query, waybillNo: e.target.value })}
                    onKeyDown={(e) => e.key === 'Enter' && handleQuery()}
                  />
                </div>
              </div>
              <Button onClick={handleQuery} icon={<FaSearch />} className="whitespace-nowrap">
                查询
              </Button>
              <Button variant="secondary" onClick={handleReset} icon={<FaRedo />} className="whitespace-nowrap">
                重置
              </Button>
            </div>
            {!isAuthenticated && (
              <p className="text-sm text-gray-500 mt-3">
                未登录状态下可凭「订单号 / 运单号 + 收件人手机号后四位」查询单条订单信息。
              </p>
            )}
          </Card.Body>
        </Card>

        {/* 校验查得的订单（游客 / 登录用户查询非本人订单） */}
        {queryResult && (
          <Card className="mb-6">
            <Card.Header>
              <div className="flex items-center justify-between">
                <h4 className="font-semibold">查询结果</h4>
                <button
                  type="button"
                  className="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-md border border-primary-200 text-primary-600 hover:bg-primary-50 transition-colors"
                  onClick={() => openDetail(queryResult)}
                >
                  <FaEye className="w-3.5 h-3.5" />
                  详情
                </button>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="grid grid-cols-fluid-xs gap-4 text-sm">
                <div>
                  <p className="text-gray-500 mb-1">订单号</p>
                  <p className="font-medium">{queryResult.orderNo || '-'}</p>
                </div>
                <div>
                  <p className="text-gray-500 mb-1">运单号</p>
                  <p className="font-medium">{queryResult.waybillNo || '-'}</p>
                </div>
                <div>
                  <p className="text-gray-500 mb-1">货物类型</p>
                  <p className="font-medium">{queryResult.cargoType || '-'}</p>
                </div>
                <div>
                  <p className="text-gray-500 mb-1">货物名称</p>
                  <p className="font-medium">{queryResult.cargoName || '-'}</p>
                </div>
                <div>
                  <p className="text-gray-500 mb-1">收件人</p>
                  <p className="font-medium">{queryResult.recipient || '-'}</p>
                </div>
                <div>
                  <p className="text-gray-500 mb-1">手机号</p>
                  <p className="font-medium">{queryResult.phone || '-'}</p>
                </div>
                <div>
                  <p className="text-gray-500 mb-1">运输方案</p>
                  <p className="font-medium">{queryResult.transportPlan || '-'}</p>
                </div>
                <div>
                  <p className="text-gray-500 mb-1">选择柜型</p>
                  <p className="font-medium">{queryResult.containerType || '-'}</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        )}

        {/* 下方订单列表：仅登录用户展示本人订单 */}
        {isAuthenticated && (
          <Card>
            <Card.Body className="p-0">
              {filteredMyOrders.length > 0 ? (
                <>
                  {/* 小屏卡片视图 */}
                  <div className="md:hidden space-y-3 p-4">
                    {filteredMyOrders.map((order) => (
                      <MobileCard
                        key={order.id}
                        title={order.cargoName}
                        subtitle={[order.orderNo, order.transportPlan].filter(Boolean).join('  ·  ')}
                        badge={<span className="text-xs text-gray-500">{order.cargoType}</span>}
                        fields={[
                          { label: '收件人', value: `${order.recipient}  ${order.phone}` },
                          { label: '下单', value: order.orderTime },
                          ...(expandedRows[order.id]
                            ? [
                              { label: '运单号', value: order.waybillNo },
                              { label: '柜型', value: order.containerType },
                              { label: '件数/重量', value: `${order.pieces} 件 · ${order.weight} KG` },
                              { label: '体积', value: `${order.volume.toFixed(4)} CBM` },
                              { label: '收件地址', value: order.address },
                              { label: '备注', value: order.remark || '无' },
                            ]
                            : []),
                        ]}
                        actions={
                          <>
                            <button
                              type="button"
                              className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-md border border-primary-200 text-primary-600 hover:bg-primary-50"
                              onClick={() => openDetail(order)}
                            >
                              <FaEye className="w-3.5 h-3.5" />
                              详情
                            </button>
                            <button
                              type="button"
                              className="ml-auto px-2 py-1.5 text-xs text-gray-500 hover:text-primary-600"
                              onClick={() => toggleExpandRow(order)}
                            >
                              {expandedRows[order.id] ? '收起' : '更多'}
                            </button>
                          </>
                        }
                      />
                    ))}
                  </div>

                  {/* 13 处表格里唯一漏了 overflow-x 的一处：列多且表头全 nowrap，
                      小屏会把整页撑出横向滚动条。这里补上，并只在 ≥md 显示。 */}
                  <div className="hidden md:block overflow-x-auto">
                  <table className="table w-full">
                    <thead>
                      <tr>
                        <th className="text-center" style={{ width: 44 }}></th>
                        <th className="whitespace-nowrap text-center">货物类型</th>
                        <th className="whitespace-nowrap text-center">货物名称</th>
                        <th className="whitespace-nowrap text-center">收件人</th>
                        <th className="whitespace-nowrap text-center">手机号</th>
                        <th className="whitespace-nowrap text-center">收件地址</th>
                        <th className="whitespace-nowrap text-center">运输方案</th>
                        <th className="whitespace-nowrap text-center">选择柜型</th>
                        <th className="whitespace-nowrap text-center">下单时间</th>
                        <th className="whitespace-nowrap text-center">操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredMyOrders.map((order) => (
                        <Fragment key={order.id}>
                          <tr>
                            <td className="text-center" style={{ width: 50 }}>
                              <button
                                type="button"
                                className="p-1.5 text-gray-500 hover:text-primary-600 hover:bg-gray-100 rounded-full transition-colors"
                                onClick={() => toggleExpandRow(order)}
                                title={expandedRows[order.id] ? '收起' : '展开'}
                              >
                                {expandedRows[order.id] ? <FaChevronDown className="w-3.5 h-3.5" /> : <FaChevronRight className="w-3.5 h-3.5" />}
                              </button>
                            </td>
                            <td className="whitespace-nowrap text-center">{order.cargoType}</td>
                            <td className="whitespace-nowrap text-center">{order.cargoName}</td>
                            <td className="whitespace-nowrap text-center">{order.recipient}</td>
                            <td className="whitespace-nowrap text-center">{order.phone}</td>
                            <td className="text-center max-w-[180px] truncate" title={order.address}>{order.address}</td>
                            <td className="whitespace-nowrap text-center">{order.transportPlan}</td>
                            <td className="whitespace-nowrap text-center">{order.containerType}</td>
                            <td className="whitespace-nowrap text-center">{order.orderTime}</td>
                            <td className="whitespace-nowrap text-center">
                              <div className="flex items-center justify-center">
                                <button
                                  type="button"
                                  className="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-md border border-primary-200 text-primary-600 hover:bg-primary-50 transition-colors"
                                  onClick={() => openDetail(order)}
                                >
                                  <FaEye className="w-3.5 h-3.5" />
                                  详情
                                </button>
                              </div>
                            </td>
                          </tr>
                          {expandedRows[order.id] && (
                            <tr>
                              <td colSpan={10} className="bg-gray-50 px-4 py-3">
                                <div className="grid grid-cols-fluid-sm gap-3 text-sm">
                                  <div><span className="text-gray-500">订单号：</span>{order.orderNo}</div>
                                  <div><span className="text-gray-500">运单号：</span>{order.waybillNo}</div>
                                  <div><span className="text-gray-500">件数：</span>{order.pieces} 件</div>
                                  <div><span className="text-gray-500">重量：</span>{order.weight} KG</div>
                                  <div><span className="text-gray-500">体积：</span>{order.volume.toFixed(4)} CBM</div>
                                  <div className="md:col-span-2 lg:col-span-3"><span className="text-gray-500">收件地址：</span>{order.address}</div>
                                  <div className="md:col-span-2 lg:col-span-4"><span className="text-gray-500">备注：</span>{order.remark || '无'}</div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </Fragment>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </>
              ) : (
                <EmptyState
                  title="暂无订单记录"
                  description="没有找到符合条件的订单，或您还没有下单"
                  actionLabel="立即下单"
                  action={() => (window.location.href = '/order-create')}
                />
              )}
            </Card.Body>
          </Card>
        )}
      </div>

      <PhoneTailVerifyModal
        visible={verifyModal.visible}
        code={verifyModal.code}
        subject="订单"
        onCancel={() => setVerifyModal({ visible: false, code: '' })}
        onConfirm={handleVerify}
      />


      {/* 订单详情弹窗 */}
      {detailModal.visible && detailModal.order && (
        <Modal
          open
          onClose={closeDetail}
          size="xl"
          title={
            <span className="flex items-center gap-2">
              <FaClipboardList className="text-primary-600" />
              订单详情
            </span>
          }
          footer={
            <div className="flex justify-end">
              <button className="btn btn-secondary w-full sm:w-auto" type="button" onClick={closeDetail}>关闭</button>
            </div>
          }
        >
            <div className="space-y-4">
              <div className="grid grid-cols-fluid-sm gap-x-6 gap-y-4 text-sm">
                <div><p className="text-gray-500 mb-1">订单号</p><p className="font-medium break-all">{detailModal.order.orderNo}</p></div>
                <div><p className="text-gray-500 mb-1">运单号</p><p className="font-medium break-all">{detailModal.order.waybillNo}</p></div>
                <div><p className="text-gray-500 mb-1">货物类型</p><p className="font-medium">{detailModal.order.cargoType}</p></div>
                <div><p className="text-gray-500 mb-1">货物名称</p><p className="font-medium">{detailModal.order.cargoName}</p></div>
                <div><p className="text-gray-500 mb-1">收件人</p><p className="font-medium">{detailModal.order.recipient}</p></div>
                <div><p className="text-gray-500 mb-1">手机号</p><p className="font-medium">{detailModal.order.phone}</p></div>
                <div><p className="text-gray-500 mb-1">运输方案</p><p className="font-medium">{detailModal.order.transportPlan}</p></div>
                <div><p className="text-gray-500 mb-1">选择柜型</p><p className="font-medium">{detailModal.order.containerType}</p></div>
                <div><p className="text-gray-500 mb-1">件数</p><p className="font-medium">{detailModal.order.pieces} 件</p></div>
                <div><p className="text-gray-500 mb-1">重量</p><p className="font-medium">{detailModal.order.weight} KG</p></div>
                <div><p className="text-gray-500 mb-1">体积</p><p className="font-medium">{detailModal.order.volume.toFixed(4)} CBM</p></div>
                <div><p className="text-gray-500 mb-1">下单时间</p><p className="font-medium">{detailModal.order.orderTime}</p></div>
                <div className="sm:col-span-2"><p className="text-gray-500 mb-1">收件地址</p><p className="font-medium break-all">{detailModal.order.address}</p></div>
                <div className="sm:col-span-2"><p className="text-gray-500 mb-1">备注</p><p className="font-medium break-all">{detailModal.order.remark || '无'}</p></div>
              </div>
            </div>
        </Modal>
      )}
    </div>
  )
}
